module.exports = __webpack_public_path__ + "static/media/delivery-page.55a47d57.jpg";